/**
 * 토너먼트 메타 채널 클라이언트 — `/parties/tournament/{TID}`.
 * 매치는 별도 Room DO 에 AllinClient 로 따로 연결한다 (옵션 B).
 */

import { PartySocket } from "partysocket";
import { TClientMsg, TServerMsg } from "./tournament-protocol";

type Listener = (msg: TServerMsg) => void;

export class TournamentClient {
  private socket: PartySocket | null = null;
  private listeners = new Set<Listener>();
  private statusListeners = new Set<(s: "open" | "close" | "error") => void>();

  constructor(
    private readonly host: string,
    private readonly tournamentId: string,
  ) {}

  connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      const ws = new PartySocket({
        host: this.host,
        party: "tournament",
        room: this.tournamentId,
      });
      this.socket = ws;
      ws.addEventListener("message", (e: MessageEvent<string>) => {
        try {
          const msg = JSON.parse(e.data) as TServerMsg;
          for (const l of this.listeners) l(msg);
        } catch (err) {
          console.error("bad t-msg:", e.data, err);
        }
      });
      ws.addEventListener("open", () => {
        for (const l of this.statusListeners) l("open");
        resolve();
      });
      ws.addEventListener("close", () => {
        for (const l of this.statusListeners) l("close");
      });
      ws.addEventListener("error", (err) => {
        for (const l of this.statusListeners) l("error");
        reject(err);
      });
    });
  }

  hello(participantId: string, name: string) {
    this.send({ type: "t_hello", participantId, name });
  }
  startTournament() { this.send({ type: "t_start_tournament" }); }
  toggleReady(matchId: string) { this.send({ type: "t_match_ready_toggle", matchId }); }
  afterMatchChoice(choice: "spectate" | "leave") { this.send({ type: "t_after_match_choice", choice }); }
  leaveRoom() { this.send({ type: "t_leave_room" }); }

  send(msg: TClientMsg) {
    if (!this.socket) throw new Error("not connected");
    this.socket.send(JSON.stringify(msg));
  }

  onMessage(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  onStatus(listener: (s: "open" | "close" | "error") => void): () => void {
    this.statusListeners.add(listener);
    return () => this.statusListeners.delete(listener);
  }

  disconnect() {
    this.socket?.close();
    this.socket = null;
  }
}
